import { Alert } from '@mui/material'
import React from 'react'

import { SignedOutForm } from 'components/authentication/SignedOutForm'
import SignedOutFormContainer from 'components/authentication/SignedOutFormContainer'
import { UpperBackText } from 'components/authentication/UpperBackText'
import theme from 'theme'
import { UserAuthCompany } from 'types/api/user/session'
import { getCompanyName } from 'utils/company'
import { naturalSortBy } from 'utils/list'

export const CompanyListForm: React.FC<{
  companies: UserAuthCompany[]
  handleCompanySelection: (companyName: string) => Promise<void>
  handleBack: () => void
  submitting: boolean
  signInError?: string
}> = ({
  companies,
  handleCompanySelection,
  handleBack,
  submitting,
  signInError
}) => {
  const sortedCompanies = naturalSortBy(companies, (company) =>
    getCompanyName(company)
  )
  return (
    <SignedOutFormContainer>
      <UpperBackText onClick={handleBack}>Back to login</UpperBackText>
      <SignedOutForm title="Select company">
        {sortedCompanies.map((company, index) => (
          <Company
            key={company.name}
            company={company}
            handleCompanySelection={handleCompanySelection}
            index={index}
            submitting={submitting}
            total={companies.length}
          />
        ))}
        {signInError && (
          <Alert
            data-testid="sign-in-credentials-error"
            id="signin-error"
            severity="error"
            sx={{ marginTop: 3 }}
          >
            {signInError}
          </Alert>
        )}
      </SignedOutForm>
    </SignedOutFormContainer>
  )
}

const Company: React.FC<{
  company: UserAuthCompany
  handleCompanySelection: (companyName: string) => void
  index: number
  total: number
  submitting: boolean
}> = ({ company, handleCompanySelection, index, total, submitting }) => {
  return (
    <div
      css={{
        textAlign: 'left',
        marginLeft: -theme.space[7],
        marginRight: -theme.space[7],
        paddingLeft: theme.space[7],
        paddingRight: theme.space[7],
        cursor: 'pointer',
        transition: '150ms background-color',
        '&:hover': {
          backgroundColor: theme.colors.grayOverlay[0]
        }
      }}
      data-test-company-list-company={company.name}
      onClick={() => {
        if (submitting) return
        handleCompanySelection(company.name)
      }}
    >
      <div
        css={{
          ...(index < total - 1 && {
            borderBottom: theme.border.base
          }),
          paddingTop: theme.space[3],
          paddingBottom: theme.space[3]
        }}
      >
        {getCompanyName(company)}
      </div>
    </div>
  )
}
